define((require) => {
    "use strict";

    const Class           = require("shared/util/Class");
    const Preconditions   = require("shared/util/Preconditions");

    /**
     * Abstract query representation.
     *
     * @class ChunkingCollectionQuery
     * @see ChunkingCollection
     */
    const ChunkingCollectionQuery = Class.extend("ChunkingCollectionQuery", {

        /**
         * Returns the raw representation of *this* query, i.e. the object passed to the supporting endpoint.
         *
         * @return {Object} The raw query representation.
         */
        querify() {
            Preconditions.abstractMethodError();
        },

        /**
         * Returns a clone of *this* query.
         *
         * @return {ChunkingCollectionQuery} The cloned query.
         */
        clone() {
            Preconditions.abstractMethodError();
        }

    });

    return ChunkingCollectionQuery;
});



// WEBPACK FOOTER //
// ./src/editor/data/ChunkingCollectionQuery.js